import { Flex,  Text } from "@aws-amplify/ui-react";
import { CommonDivider } from '../../../ui-components';
import {
  inputNumberLimit,
  signalKanshiSettingJson,
  convertStatusTypeValueToSelectValue,
  convertSelectValueToStatusTypeValue,
  SETTING_INPUTBOX_UNIT_NOTHING,
} from '../../../lib/SettingUtil';

import {
  SetteiItemWrapper,
} from '../../../componentsWrapper';

const CalibrationPathMonitoring = ({
  editSettingJson,
  setEditSettingJson,
}) => {

  return (
    <>
      <Flex
        gap="16px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
      >
        <Text
          fontFamily="Noto Sans"
          fontSize="16px"
          fontWeight="700"
          color="rgba(53,56,59,1)"
          lineHeight="16px"
          textAlign="left"
          display="block"
          direction="column"
          justifyContent="unset"
          letterSpacing="0.65px"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="校正経路監視"
        // {...getOverrideProps(overrides, "text505156939")}
        ></Text>
        <Flex
          gap="0"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
        // {...getOverrideProps(overrides, "Frame 881")}
        >
          <Flex
            gap="48px"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="16px 32px 16px 32px"
            backgroundColor="rgba(245,245,245,1)"
          // {...getOverrideProps(overrides, "Title")}
          >
            <Text
              fontFamily="Noto Sans"
              fontSize="16px"
              fontWeight="400"
              color="rgba(53,56,59,1)"
              lineHeight="16px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              letterSpacing="0.65px"
              width="96px"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="スペアナ"
            // {...getOverrideProps(overrides, "text505156942")}
            ></Text>
            <Text
              fontFamily="Noto Sans"
              fontSize="16px"
              fontWeight="400"
              color="rgba(53,56,59,1)"
              lineHeight="16px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              letterSpacing="0.65px"
              width="160px"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="アンテナ"
            // {...getOverrideProps(overrides, "text505156943")}
            ></Text>
            <Text
              fontFamily="Noto Sans"
              fontSize="16px"
              fontWeight="400"
              color="rgba(53,56,59,1)"
              lineHeight="16px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              letterSpacing="0.65px"
              width="120px"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="有効／無効"
            // {...getOverrideProps(overrides, "text505156944")}
            ></Text>
            <Text
              fontFamily="Noto Sans"
              fontSize="16px"
              fontWeight="400"
              color="rgba(53,56,59,1)"
              lineHeight="16px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              letterSpacing="0.65px"
              width="120px"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="状態種別"
            // {...getOverrideProps(overrides, "text505156945")}
            ></Text>
            <Text
              fontFamily="Noto Sans"
              fontSize="16px"
              fontWeight="400"
              color="rgba(53,56,59,1)"
              lineHeight="16px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              letterSpacing="0.65px"
              width="120px"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="閾値"
            // {...getOverrideProps(overrides, "text505156946")}
            ></Text>
          </Flex>
          <Flex
            gap="0"
            direction="column"
            width="unset"
            // height="500px"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            overflow="hidden"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
          // {...getOverrideProps(overrides, "Frame")}
          >
            {editSettingJson !== null &&
              Object.entries(signalKanshiSettingJson).map((supeana, index) => (
                <>
                  <Flex
                    key={"FrameA" + index}
                    gap="0"
                    direction="row"
                    width="unset"
                    height="unset"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                  // {...getOverrideProps(overrides, "3400-3440")}
                  >
                    <Flex
                      key={"FrameB" + index}
                      gap="0"
                      direction="row"
                      width="unset"
                      height="unset"
                      justifyContent="center"
                      alignItems="flex-start"
                      shrink="0"
                      alignSelf="stretch"
                      position="relative"
                      padding="34px 32px 34px 32px"
                      backgroundColor="rgba(255,255,255,1)"
                    // {...getOverrideProps(overrides, "Taisyo505156949")}
                    >
                      <Text
                        key={"label" + index}
                        fontFamily="Noto Sans"
                        fontSize="14px"
                        fontWeight="700"
                        color="rgba(53,56,59,1)"
                        lineHeight="22.399999618530273px"
                        textAlign="left"
                        display="block"
                        direction="column"
                        justifyContent="unset"
                        letterSpacing="0.55px"
                        width="88px"
                        height="unset"
                        gap="unset"
                        alignItems="unset"
                        shrink="0"
                        position="relative"
                        padding="0px 0px 0px 0px"
                        whiteSpace="nowrap"
                        children={supeana[0] == "S1" ? "スペアナ１" : "スペアナ２"}
                      // {...getOverrideProps(overrides, "text505156950")}
                      ></Text>
                    </Flex>
                    <Flex
                      key={"FrameC" + index}
                      gap="0"
                      direction="column"
                      width="unset"
                      height="unset"
                      justifyContent="flex-start"
                      alignItems="flex-start"
                      shrink="0"
                      position="relative"
                      padding="0px 0px 0px 0px"
                    // {...getOverrideProps(overrides, "Frame 880505156951")}
                    >
                      {Object.entries(supeana[1]).map((antena, index) => (
                        Object.entries(antena[1]).map((itemDetail, index) => (
                          <>
                            <SetteiItemWrapper
                              key={supeana[0] + "-" + antena[0] + "setting" + index}
                              setteiname={itemDetail[1].labeltext}
                              isvalidoptions={itemDetail[1].isvalidoptions}
                              isvalidvalue={editSettingJson[supeana[0] + "-" + antena[0]][itemDetail[0]].Monitoring != null && editSettingJson[supeana[0] + "-" + antena[0]][itemDetail[0]].Monitoring ? "ON" : "OFF"}
                              isvalidvalueOnChange={(e) => {
                                console.log(e.target.value);

                                setEditSettingJson({
                                  ...editSettingJson,
                                  [supeana[0] + "-" + antena[0]]: {
                                    ...editSettingJson[supeana[0] + "-" + antena[0]],
                                    [itemDetail[0]]: {
                                      ...editSettingJson[supeana[0] + "-" + antena[0]][itemDetail[0]],
                                      Monitoring: e.target.value === "ON" ? true : false
                                    }
                                  }
                                });
                              }}

                              statustypeoptions={itemDetail[1].statustypeoptions}
                              statustypevalue={convertStatusTypeValueToSelectValue(editSettingJson[supeana[0] + "-" + antena[0]][itemDetail[0]].Status_Type)}
                              statustypevalueOnChange={(e) => {
                                console.log(e.target.value);
                                console.log(convertSelectValueToStatusTypeValue(e.target.value));

                                setEditSettingJson({
                                  ...editSettingJson,
                                  [supeana[0] + "-" + antena[0]]: {
                                    ...editSettingJson[supeana[0] + "-" + antena[0]],
                                    [itemDetail[0]]: {
                                      ...editSettingJson[supeana[0] + "-" + antena[0]][itemDetail[0]],
                                      Status_Type: convertSelectValueToStatusTypeValue(e.target.value)
                                    }
                                  }
                                });
                              }}
                              display1={itemDetail[1].option1 ? "flex" : "none"}
                              texttop1={"21px"}
                              label1={itemDetail[1].option1 && itemDetail[1].option1.labeltext ? "true" : "false"}
                              labelValue1={itemDetail[1].option1 && itemDetail[1].option1.labeltext ? itemDetail[1].option1.labeltext : ""}
                              attention1={itemDetail[1].option1 && itemDetail[1].option1.range ? "範囲：" + itemDetail[1].option1.range.min + "-" + itemDetail[1].option1.range.max : ""}
                              attentiontext1={itemDetail[1].option1 && itemDetail[1].option1.range ? "範囲：" + itemDetail[1].option1.range.min + "-" + itemDetail[1].option1.range.max : ""}
                              unit1={itemDetail[1].option1 && itemDetail[1].option1.unit ? itemDetail[1].option1.unit : SETTING_INPUTBOX_UNIT_NOTHING}
                              inputValue1={editSettingJson[supeana[0] + "-" + antena[0]][itemDetail[0]].Value != null ? editSettingJson[supeana[0] + "-" + antena[0]][itemDetail[0]].Value : ""}
                              inputType1={itemDetail[1].option1.input.type}
                              {
                              ...itemDetail[1].option1.input.type == "number" && {
                                inputStep1: itemDetail[1].option1.input.step,
                                ...itemDetail[1].option1.range !== null && {
                                  inputMax1: itemDetail[1].option1.range.max,
                                  inputMin1: itemDetail[1].option1.range.min,
                                }
                              }
                              }
                              inputValue1OnChange={(e) => {
                                setEditSettingJson({
                                  ...editSettingJson,
                                  [supeana[0] + "-" + antena[0]]: {
                                    ...editSettingJson[supeana[0] + "-" + antena[0]],
                                    [itemDetail[0]]: {
                                      ...editSettingJson[supeana[0] + "-" + antena[0]][itemDetail[0]],
                                      Value: e.target.value,
                                    }
                                  }
                                });
                              }}
                              inputValue1OnBlur={(e) => {
                                let value = e.target.value;
                                console.log(value);

                                // 数字の場合
                                if (itemDetail[1].option1.input.type === "number") {
                                  // 整数の場合
                                  value = inputNumberLimit(value, itemDetail[1].option1.input.step, itemDetail[1].option1.range)
                                }
                                console.log(value);

                                setEditSettingJson(prev => {
                                  return {
                                    ...editSettingJson,
                                    [supeana[0] + "-" + antena[0]]: {
                                      ...editSettingJson[supeana[0] + "-" + antena[0]],
                                      [itemDetail[0]]: {
                                        ...editSettingJson[supeana[0] + "-" + antena[0]][itemDetail[0]],
                                        Value: value,
                                      }
                                    }
                                  }
                                });
                              }}
                              display2={itemDetail[1].option2 ? "flex" : "none"}
                              display3={itemDetail[1].option3 ? "flex" : "none"}
                              display4={itemDetail[1].option4 ? "flex" : "none"}
                            ></SetteiItemWrapper>
                          </>
                        ))))}
                    </Flex>

                  </Flex>
                  <CommonDivider
                    key={"divider" + index}
                    display="flex"
                    gap="0"
                    direction="row"
                    width="unset"
                    height="1px"
                    justifyContent="center"
                    alignItems="center"
                    overflow="hidden"
                    shrink="0"
                    alignSelf="stretch"
                    position="relative"
                    padding="0px 0px 0px 0px"
                  // {...getOverrideProps(overrides, "Common/Divider505156955")}
                  ></CommonDivider>
                </>
              ))}
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};

export default CalibrationPathMonitoring;